/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_NewInputs */

const cs_jobs_new = /** @type {(inputs: Jobs_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nové`)
};

const en_jobs_new = /** @type {(inputs: Jobs_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`new`)
};

/**
* | output |
* | --- |
* | "new" |
*
* @param {Jobs_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_new = /** @type {((inputs?: Jobs_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_new(inputs)
	return cs_jobs_new(inputs)
});